import { clsx } from 'clsx';

type PreorderNoticeProps = {
  message?: string;
  variant?: `badge` | `tag`;
  className?: string;
};

/**
 * Communicates that a book is a pre-order. Two variants:
 * - `badge` (default): a callout used on the shop card and product page,
 *   shown above/near the purchase CTA.
 * - `tag`: a compact inline note used in the cart drawer and checkout
 *   order summary, shown under the item title.
 */
const PreorderNotice = ({
  message,
  variant = `badge`,
  className,
}: PreorderNoticeProps) => {
  if (variant === `tag`) {
    return (
      <p className={clsx(`text-xs text-accent-400 !mb-0`, className)}>
        <span className="font-bold uppercase tracking-wide">Preorder</span>
        {message ? <> · {message}</> : null}
      </p>
    );
  }

  return (
    <div
      className={clsx(
        `mb-2 flex flex-col items-start gap-2 rounded-md`,
        `border border-accent-500/40 bg-accent-500/10 px-3 py-2`,
        `lg:flex-row`,
        className,
      )}
    >
      <span className="shrink-0 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold uppercase tracking-wide text-black">
        Preorder
      </span>
      {message ? (
        <p className="text-xs text-primary-300 !my-0">{message}</p>
      ) : null}
    </div>
  );
};

export default PreorderNotice;
